import React, {useEffect, useState} from 'react';
import { Button, Col, Grid, Row } from "react-bootstrap";
import { adminActions } from '../../../../../state/modules/admin';
import { eventHandler } from "../../../../../utils";
import { FileUploadFormField, InputFormField } from "../../../../components";
import {compose} from 'recompose';
import {connect} from 'react-redux';
import prettyBytes from 'pretty-bytes';
import he from 'he';
import {bindActionCreators} from 'redux';
import {publisherActions} from '../../../../../state/modules/publisher';
import {routes} from '../../../../../constants';
import {LinkContainer} from 'react-router-bootstrap';
import {contentConfigSelector} from '../../../../../state/modules/configuration/selectors';


const PublisherUpdate = ({ publishers, match, updatePublisher, state, getPublishers, config }) => {
  const { publisherId } = match.params;

  const publisher = publishers.find((publisher) => publisher.id.toString() === publisherId);

  const [updatedPublisher, setUpdatedPublisher] = useState();
  const [previewLogoImage, setPreviewLogoImage] = useState();
  const [validation, setValidation] = useState({
    previewImage: false
  });

  const submitUpdatePublisher = () => {
    updatePublisher(updatedPublisher.id, {
      data: updatedPublisher,
      file: previewLogoImage !== undefined ? [
        { key: 'logoImage', value: previewLogoImage }
      ] : []
    });
  }

  const onLogoFileDrop = (acceptedFiles, rejectedFiles) => {
    const acceptedFile = acceptedFiles[0];
    const rejectedFile = rejectedFiles[0];

    if (acceptedFile) {
      setPreviewLogoImage(acceptedFile);
      setValidation({
        previewImage: true
      });
    }

    if (rejectedFile) {
      setValidation({
        previewImage: false
      });
    }
  }

  // Invoke only once on load with empty dependencies.
  useEffect(() => {
    getPublishers();
  }, []);

  useEffect(() => {
    setUpdatedPublisher(publisher);
  }, [publisher]);


  if (updatedPublisher === undefined) {
    // TODO: redirect back to publisher table.
    return <div></div>;
  }

  return (
    <Grid>
      <Row>
        <Col xs={12} md={8} mdOffset={2}>
          <h1>Update {updatedPublisher.name}</h1>
        </Col>
      </Row>
      <Row>
        <form noValidate onSubmit={eventHandler(submitUpdatePublisher)}>
          <fieldset>
            <Col xs={12} md={8} mdOffset={2}>
              <InputFormField {...{
                id: 'publisher',
                label: 'Publisher name',
                required: true,
                value: updatedPublisher.name,
                onChange: (e) => setUpdatedPublisher( { ...updatedPublisher, name: e.target.value })
              }} />
            </Col>
            {
              updatedPublisher.logoPreviewImageUrl && !validation.previewImage ?
                <Col xs={12} md={8} mdOffset={2} className="text-center">
                  <div className='text-center preview-image existing'>
                    <img alt={updatedPublisher.logoImageFileName} src={he.decode(updatedPublisher.logoPreviewImageUrl)} />
                  </div>
                </Col>
                : null
            }
            {
              previewLogoImage && validation.previewImage ?
                <Col xs={12} md={8} mdOffset={2} className="text-center">
                  <div className='text-center preview-image existing'>
                    <img alt="Preview logo" src={window.URL.createObjectURL(previewLogoImage)} />
                  </div>
                </Col>
                : null
            }
            <Col xs={12} md={8} mdOffset={2}>
              <FileUploadFormField
                styleName='file-5'
                accept='image/png,image/jpeg'
                multiple={false}
                onFileDrop={onLogoFileDrop}
                file={previewLogoImage}
                maxSize={config.maxImageFileSizeBytes}
                validationMessage={validation.previewImage ? null : 'Please select image (JPG, PNG) file (max file size ' + prettyBytes(config.maxImageFileSizeBytes) + ').'}
                dropLabel='Upload logo image (JPG, PNG)' />
            </Col>
            <Col xs={10} xsOffset={1} md={6} mdOffset={3}>
              <Button type='submit' className='large filled'>Update publisher</Button>
            </Col>
          </fieldset>
        </form>
        <Col xs={12} xsOffset={1} md={6} mdOffset={3}>
          <LinkContainer to={{ pathname: routes.adminPortal.publisher }} style={{ width: "100%", border: "1px solid" }}>
            <Button bsStyle='plain'>Cancel</Button>
          </LinkContainer>
        </Col>
      </Row>
    </Grid>
  )
};

const mapStateToProps = (state) => ({
  publishers: state.publisher.publisherStats,
  config: contentConfigSelector(state),
  state: state,
});

const mapDispatchToProps = (dispatch) => ({
  updatePublisher: bindActionCreators(adminActions.admin.updatePublisher, dispatch),
  getPublishers: bindActionCreators(publisherActions.publishers.getStats, dispatch)
});


export default compose(connect(mapStateToProps, mapDispatchToProps))(PublisherUpdate);



// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/publisher-portal/partials/publisherUpdate.js